module.exports = __webpack_public_path__ + "images/dutchlease71caed50fb63be80edd068397198b415.png";